// CustomListContext — estado y handlers de la "lista personalizada generada"
// del evento (canciones a tocar, filtros, reorden, marcar como reproducidas).
// Aislado del MainAppContext (Fase 3 — Paso 3, Feb 2026).
import { createContext, useContext } from "react";

export const CustomListContext = createContext(null);

export const useCustomList = () => {
  const ctx = useContext(CustomListContext);
  if (ctx === null) {
    throw new Error("useCustomList debe usarse dentro de <CustomListContext.Provider>");
  }
  return ctx;
};
